<template>
  <form
    method="post"
    class="form-horizontal"
    autocomplete="off"
    @submit.prevent="submitForm"
  >
    <slot />
  </form>
</template>

<script setup lang="ts">
const emit = defineEmits(['submit']);

const submitForm = (event: any) => {
  const submitter = event.submitter as HTMLElement | null;

  /*
    Checking form is submitted by user or google library
    When user clicks back button on Google map,
    submit action is occurred and we don't submit form
  */
  if (submitter?.classList.contains('gm-iv-close')) {
    return;
  }

  emit('submit', event);
};
</script>
